import { SettingConst } from '../../types';

/**
 * Experiment setting for Decagon AI chatbot in the Help Center
 */
export const HELP_CENTER_AI_CHATBOT_240903 =
  'HELP_CENTER_AI_CHATBOT_240903' as SettingConst<
    'HELP_CENTER_AI_CHATBOT_240903',
    boolean,
    'HELP_CENTER' | 'HOTJAR_HELP_CENTER'
  >;
